export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '81推荐奖励记录';